<app-modal
  [isOpen]="true"
  [modalTitle]="'Charge History'"
  [maxWidth]="'max-w-4xl'"
  [minHeight]="'500px'"
  (close)="onClose()">
  <div class="bg-white rounded-lg border border-slate-200 overflow-hidden">
    <div class="border-b border-slate-200 bg-slate-50">
      <div class="flex items-center gap-4 px-4 pt-3">
        <button
          type="button"
          class="px-3 pb-2 text-xs font-semibold border-b-2"
          [class.border-primary]="activeTab === 'submit'"
          [class.text-primary]="activeTab === 'submit'"
          [class.border-transparent]="activeTab !== 'submit'"
          [class.text-slate-500]="activeTab !== 'submit'"
          (click)="setTab('submit')">
          Submit ({{ submitRows.length }})
        </button>
        <button
          type="button"
          class="px-3 pb-2 text-xs font-semibold border-b-2"
          [class.border-primary]="activeTab === 'resubmit'"
          [class.text-primary]="activeTab === 'resubmit'"
          [class.border-transparent]="activeTab !== 'resubmit'"
          [class.text-slate-500]="activeTab !== 'resubmit'"
          (click)="setTab('resubmit')">
          Resubmit ({{ resubmitRows.length }})
        </button>
        <button
          type="button"
          class="px-3 pb-2 text-xs font-semibold border-b-2"
          [class.border-primary]="activeTab === 'editing'"
          [class.text-primary]="activeTab === 'editing'"
          [class.border-transparent]="activeTab !== 'editing'"
          [class.text-slate-500]="activeTab !== 'editing'"
          (click)="setTab('editing')">
          Editing ({{ editingRows.length }})
        </button>
      </div>
    </div>

    <div class="p-4 bg-slate-50 min-h-[360px]">
      <div class="mb-3 text-xs text-slate-500" *ngIf="chargeNo">
        Charge #{{ chargeNo }}
      </div>

      <div *ngIf="isLoading" class="min-h-[320px] flex items-center justify-center text-sm text-slate-500">
        <i class="fas fa-spinner fa-spin mr-2"></i>
        Loading charge history...
      </div>

      <div *ngIf="!isLoading && loadError" class="min-h-[320px] flex items-center justify-center text-sm text-rose-600">
        {{ loadError }}
      </div>

      <div *ngIf="!isLoading && !loadError" class="bg-white border border-slate-200 rounded-md overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full text-xs">
            <thead class="bg-slate-100 border-b border-slate-200">
              <tr>
                <th class="px-3 py-2 text-left font-semibold text-slate-700">Submit Date</th>
                <th class="px-3 py-2 text-left font-semibold text-slate-700">User</th>
                <th class="px-3 py-2 text-left font-semibold text-slate-700">Submit Type</th>
                <th class="px-3 py-2 text-left font-semibold text-slate-700">Plan</th>
                <th class="px-3 py-2 text-left font-semibold text-slate-700">Comments</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of visibleRows; trackBy: trackByHistory">
                <td class="px-3 py-2 text-slate-700 whitespace-nowrap">{{ formatHistoryDate(row.chargeHistoryDateTime) }}</td>
                <td class="px-3 py-2 text-slate-700">{{ row.chargeHistoryUserName || '-' }}</td>
                <td class="px-3 py-2 text-slate-700">{{ getHistoryType(row) || '-' }}</td>
                <td class="px-3 py-2 text-slate-700">{{ row.chargeHistoryPlanName || '-' }}</td>
                <td class="px-3 py-2 text-slate-700">{{ row.chargeHistoryComments || '-' }}</td>
              </tr>
              <tr *ngIf="visibleRows.length === 0">
                <td colspan="5" class="px-3 py-6 text-center text-slate-400 italic">
                  No data to display
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-modal>

